import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { timeout } from 'rxjs';
import StrapiService from './strapi.service';
import { IStrapiDocuments } from '../interfaces/strapi';

@Injectable()
export class UrlRedirectsService {
  constructor(
    private injector: Injector,
    private readonly strapi: StrapiService
  ) {}

  public loadUrls(): Promise<void> {
    const router = this.injector.get(Router);
    const routes = router.config;

    return new Promise((resolve) => {
      this.strapi
        .getDocumentByUID('urls', 'redirect-urls-list', {
          populate: {
            urls: true,
          },
        })
        .pipe(timeout(1000))
        .subscribe({
          next: (data: IStrapiDocuments<{ urls: RedirectUrl[] }>) => {
            if (data) {
              const { urls } = data.data[0].attributes;

              urls.forEach((item: RedirectUrl) => {
                if (!item.url_redirect) return;
                const route = routes.find((r) => item.url_link === r.path);

                if (route) {
                  route.component = undefined;
                  route.canActivate = undefined;
                  route.redirectTo = item.url_redirect;
                } else {
                  routes.unshift({
                    path: item.url_link,
                    redirectTo: item.url_redirect,
                  });
                }
              });
            }

            router.resetConfig(routes);
            resolve();
          },
          error: () => {
            resolve();
          },
        });
    });
  }
}

export type RedirectUrl = {
  url_name: string;
  url_link: string;
  url_redirect: string;
};
